import Storage from '../Storage';
import config from '../../config';
import { getStore } from '../../configureStore';
import { replace } from 'redux-little-router';
import { get } from 'lodash';

import refreshTokenRequest from '../../modules/Authorization/services/API/refreshToken';
import { remotePaths, routeMap } from '../../router/routes';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};
const unauthorized = [401];
export const refreshTokenInterceptor = (axios) => (error) => {
  const originalRequest = error.config;
  {
    // eslint-disable-next-line
    process.env.NODE_ENV === 'development' && console.error(originalRequest.url);
  }
  const refreshToken = Storage.getItem(config.refreshTokenItemName);
  if (unauthorized.includes(get(error, 'response.status')) && !originalRequest._retry) {
    if (refreshToken) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axios(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        refreshTokenRequest(refreshToken)
          .then(({ data }) => {
            Storage.setItem(config.tokenItemName, data.access_token);
            Storage.setItem(config.refreshTokenItemName, data.refresh_token);
            originalRequest.headers['Authorization'] = 'Bearer ' + data.token;
            processQueue(null, data.token);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            Storage.removeItem(config.tokenItemName);
            Storage.removeItem(config.refreshTokenItemName);
            getStore().dispatch(replace(routeMap.login));

            reject(err);
          })
          .then(() => {
            isRefreshing = false;
          });
      });
    } else {
      Storage.removeItem(config.tokenItemName);
      if (config.isInspectorArm) {
        window.location = remotePaths.taxpayerSearching;
      }
      getStore().dispatch(replace(routeMap.login));
    }
  }

  return Promise.reject(error);
};
